var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',{staticClass:"arrival size-9 roboto weight-700 nowrap white--text",attrs:{"color":"alert","rounded":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }